module.exports = __webpack_public_path__ + "img/anniversary.eac68c41.jpg";